"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_item_query_class_1 = require("./base-item-query.class");
var SingleItemQuery = /** @class */ (function (_super) {
    __extends(SingleItemQuery, _super);
    function SingleItemQuery(config, queryService, codename) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this.codename = codename;
        if (!codename) {
            throw Error("'codename' has to be configured for 'SingleItemQuery' query");
        }
        return _this;
    }
    /**
    * Gets the runnable Observable
    */
    SingleItemQuery.prototype.getObservable = function () {
        return _super.prototype.runSingleItemQuery.call(this, this.codename);
    };
    /**
    * Gets 'Url' representation of query
    */
    SingleItemQuery.prototype.getUrl = function () {
        return _super.prototype.getSingleItemQueryUrl.call(this, this.codename);
    };
    return SingleItemQuery;
}(base_item_query_class_1.BaseItemQuery));
exports.SingleItemQuery = SingleItemQuery;
//# sourceMappingURL=single-item-query.class.js.map